import InfoPopup from "common/InfoPopup/InfoPopup";

const Row = ({
  wrapperClassNames = "",
  leftValue,
  rightValue,
  noBorder,
  children,
  leftClass,
  rightClass,
  showInfoPopup,
  infoPopupMessage,
}) => {
  return (
    <div
      className={`flex-between-center ${
        noBorder ? "py-1" : "border-bottom-1 py-3"
      } ${wrapperClassNames}`}
    >
      <div className={`left-value ${leftClass}`}>
        {leftValue}
        {showInfoPopup && (
          <InfoPopup position={"right"} content={infoPopupMessage} />
        )}
      </div>

      {rightValue && (
        <div className={`right-value ${rightClass}`}>{rightValue}</div>
      )}
      {children}
    </div>
  );
};

export default Row;
